<fgai-progress [active]="currentPageNum()" [questions]="questions()" [value]="progress"
    (jump)="setPageNum($event)"></fgai-progress>
<fgai-themes [active]="currentPageNum()" [questions]="questions()"></fgai-themes>
<div class="mt-4">
    @for (question of questions(); track question.sequence_number) {
    @if (question.sequence_number === currentPageNum()) {
    <!-- transition an entire page left/right including the buttons -->
    <div [animate.enter]="forwards ? currentPageNum() !== 1 ? 'enter-from-right' : undefined : 'enter-from-left'"
        [animate.leave]="forwards ? 'leave-to-left' : 'leave-to-right'">
        <fgai-page [readonly]="readonly" [questionnaire]="questionnaire" [question]="question"
            [hideExplainDiff]="hideExplainDiff()" (explainDiffChange)="updateExplainDiff($event, question)"
            (answersChange)="updateAnswers($event, question)"></fgai-page>
        <div class="row justify-content-md-center question-number-pad-left">
            <div class="col-7">
                <div class="btn-toolbar justify-content-between">
                    <button class="btn btn-secondary" [attr.disabled]="currentPageNum() == 1 ? 'disabled': undefined"
                        (click)="goToQuestion(question, question.sequence_number - 1)">Vorige</button>
                    @if (saving()) {
                    <div class="btn btn-link btn-spinner" title="De antwoorden worden opgeslagen">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span class="visually-hidden" role="status">Opslaan...</span>
                    </div>
                    }
                    @else if (changed()) {
                    <button class="btn btn-outline-secondary btn-sm" (click)="saveQuestion(question)"
                        title="Het antwoord wordt automatisch opgeslagen wanneer naar de volgende of vorige vraag wordt gegaan.">
                        <span class="icon">
                            <fa-icon [icon]="faSave" />
                        </span>
                        antwoord is nog niet opgeslagen</button>
                    }
                    @if (currentPageNum() == lastQuestion()) {
                    @switch (questionnaire?.status) {
                    @case ('IN_PROGRESS') {
                    <button class="btn btn-primary" (click)="complete(question)">
                        Afronden</button>
                    }

                    @case ( 'PENDING_APPROVAL') {
                    <button class="btn btn-success" (click)="approve(question)">
                        Goedkeuren</button>
                    }
                    }
                    }
                    @else {
                    <button class="btn btn-primary" (click)="goToQuestion(question, question.sequence_number + 1)">
                        Volgende</button>
                    }
                </div>
            </div>
            @if (!readonly && !hideExplainDiff()) {
            <div class="col-5"></div>
            }
        </div>
    </div>
    }
    }
</div>
<br>
